import React from "react";
import { Link } from "react-router-dom";
import styles from "./PostCTA.module.css";

export default function PostCTA() {
    return (
        <div className={styles.cta}>
            <div className={styles.inner}>
                <div className={styles.icon} aria-hidden="true">💡</div>
                <div className={styles.body}>
                    <h3 className={styles.title}>
                        Pronto para levar sua empresa ao próximo nível?
                    </h3>
                    <p className={styles.text}>
                        A HL Software transforma ideias em software que realmente funciona
                        para o seu negócio. Fale com a gente e descubra como podemos
                        acelerar seus resultados com tecnologia.
                    </p>
                    <Link to="/#contato" className={styles.button}>
                        Falar com nosso time →
                    </Link>
                </div>
            </div>
        </div>
    );
}
